import React from 'react';

import { INotificationGridItem } from '../notification-grid';

import { DetailsRow } from './DetailsRow';

export const NewLeadsForSalesDetails: React.FC<INotificationGridItem> = ({
  date,
  notificationDetails: { data },
}) => (
  <>
    <DetailsRow label="Date" value={date} />
    <DetailsRow label="New Leads" value={data.newLeadsIds.length} />
    <DetailsRow
      label="Without attempt"
      value={data.newLeadsWithoutAttemptIds.length}
    />
    <DetailsRow
      label="Client IDs"
      value={data.newLeadsWithoutAttemptIds.join(', ')}
    />
  </>
);
